import { defineComponent as _defineComponent } from 'vue'
import SChipBasic from '@/components/SChipBasic.vue';
import { DbtModelDto } from '@/api';
import { computed } from 'vue';
import ProviderIcons from '@/utils/provider-icons';
import fromNow from '@/utils/filters/fromNow';
import dayjs from 'dayjs';
import i18n from '@/i18n';

interface TransformationStatusProps {
  lastRunDate: number | undefined;
  lastRunStatus: DbtModelDto.lastRunStatus | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Transformation-Status',
  props: {
  lastRunDate: null,
  lastRunStatus: null
},
  setup(__props) {

const props = __props;


const icon = ProviderIcons.DBT;
const lastRunDate = computed(() => (props.lastRunDate ? fromNow(props.lastRunDate) : undefined));
const lastRunDateAndTime = computed(() => (props.lastRunDate ? dayjs(props.lastRunDate).tz().format('YYYY-MM-DD HH:mm:ss') : undefined));
const lastRun = computed(() => {
  switch (props.lastRunStatus) {
    case DbtModelDto.lastRunStatus.SUCCESS:
      return {
        color: 'iconSuccess',
        icon: 'icon-check-circle-outline',
        status: i18n.t('assets.generating_transformation_status.success'),
      };
    case DbtModelDto.lastRunStatus.ERROR:
      return {
        color: 'iconDanger',
        icon: 'icon-error-circle-outline',
        status: i18n.t('assets.generating_transformation_status.failure'),
      };
    case DbtModelDto.lastRunStatus.SKIPPED:
      return {
        color: 'iconNeutral',
        icon: 'icon-arrow-next',
        status: i18n.t('assets.generating_transformation_status.skipped'),
      };
    case DbtModelDto.lastRunStatus.PARTIAL_SUCCESS:
      return {
        color: 'iconSuccess',
        icon: 'icon-check',
        status: i18n.t('assets.generating_transformation_status.partial_success'),
      };
    case DbtModelDto.lastRunStatus.REUSED:
      return {
        color: 'iconSuccess',
        icon: 'icon-arrow-sync',
        status: i18n.t('assets.generating_transformation_status.reused'),
      };
    case DbtModelDto.lastRunStatus.WARN:
      return {
        color: 'iconWarning',
        icon: 'icon-warning-fill',
        status: i18n.t('assets.generating_transformation_status.warn'),
      };
    case DbtModelDto.lastRunStatus.NO_OP:
      return {
        color: 'iconNeutral',
        icon: 'icon-subtract-middle',
        status: i18n.t('assets.generating_transformation_status.no_op'),
      };
    case DbtModelDto.lastRunStatus.UNKNOWN:
      return {
        color: 'iconNeutral',
        icon: 'icon-question-circle-outline',
        status: i18n.t('assets.generating_transformation_status.unknown'),
      };
    default:
      return {
        color: 'iconNeutral',
        icon: 'icon-question-circle-outline',
        status: i18n.t('assets.generating_transformation_status.default'),
      };
  }
});
const hasLastRunDate = computed(() => props.lastRunDate !== undefined && props.lastRunStatus !== DbtModelDto.lastRunStatus.NOT_TARGETED);


return { __sfc: true,props, icon, lastRunDate, lastRunDateAndTime, lastRun, hasLastRunDate, SChipBasic, DbtModelDto, computed, ProviderIcons, fromNow, dayjs, i18n }
}

})